import React from 'react';
import {
  applicationStore as applicationStoreCore,
  Header,
  tableBetHistoryStore,
} from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { observer } from 'mobx-react-lite';
import { BetHistoryWr } from '../betHistory';
import Help from '../help';
import { SettingsContainer } from '../settings';
import UserBalance from '../userBalance';
import { userInfoStore } from '../../store/userInfoStore';
import { DemoButton } from '../demoButton/demoButton';
import { applicationStore } from '../../store/applicationStore';

export const HeaderWr = observer(() => {
  const { currencyCode } = userInfoStore;
  const { setSelectedHistoryRow, selectedHistoryRow } = tableBetHistoryStore;
  const { isTestPlatform } = applicationStoreCore;
  const { isDemo, hasRealModeSwitcher } = applicationStore;

  return (
    <div className='keno-balance-content'>
      <UserBalance />
      <Header
        lobbyPath={null}
        logoSrc=''
        isShowFairness={false}
        isShowFullScreen={false}
        isShowSound={false}
        currencyCode={currencyCode}
        selectedHistoryRow={selectedHistoryRow}
        setSelectedHistoryRow={setSelectedHistoryRow}
        gameControllerComponents={{
          [GameControllerTypes.Help]: <Help />,
          [GameControllerTypes.History]: <BetHistoryWr />,
          [GameControllerTypes.Settings]: <SettingsContainer />,
        }}
      />
      {isDemo && !isTestPlatform && !hasRealModeSwitcher && <DemoButton />}
    </div>
  );
});
